var $91192e5600b60037$exports = {};
const $91192e5600b60037$var$viewPanels = Array.from(document.querySelectorAll("[data-workspace-view-panel]"));
const $91192e5600b60037$var$viewLinks = Array.from(document.querySelectorAll("[data-workspace-view-link]"));
const $91192e5600b60037$var$tabButtons = Array.from(document.querySelectorAll(".workspace-tab"));
const $91192e5600b60037$var$tabPanels = Array.from(document.querySelectorAll("[data-workspace-tab-panel]"));
const $91192e5600b60037$var$COMPATIBLE_HASHES = {
    "search-preview": {
        view: "records",
        tab: "preview"
    }
};
const $91192e5600b60037$var$state = {
    tab: "catalog",
    view: "overview"
};
function $91192e5600b60037$var$syncHistory() {
    const url = new URL(window.location.href);
    url.hash = `#${$91192e5600b60037$var$state.view}`;
    if ($91192e5600b60037$var$state.view === "records" && $91192e5600b60037$var$state.tab !== "catalog") url.searchParams.set("tab", $91192e5600b60037$var$state.tab);
    else url.searchParams.delete("tab");
    window.history.replaceState({}, "", url);
}
function $91192e5600b60037$var$dispatchWorkspaceChange() {
    window.dispatchEvent(new CustomEvent("workspace:tab-changed", {
        detail: {
            tab: $91192e5600b60037$var$state.tab,
            view: $91192e5600b60037$var$state.view
        }
    }));
}
function $91192e5600b60037$var$activateView(view) {
    $91192e5600b60037$var$state.view = view;
    $91192e5600b60037$var$viewPanels.forEach((panel)=>{
        panel.hidden = panel.dataset.workspaceViewPanel !== view;
    });
    $91192e5600b60037$var$viewLinks.forEach((link)=>{
        link.classList.toggle("is-active", link.dataset.workspaceViewLink === view);
    });
}
function $91192e5600b60037$var$activateTab(tab) {
    $91192e5600b60037$var$state.tab = tab;
    $91192e5600b60037$var$tabButtons.forEach((button)=>{
        const isActive = button.dataset.workspaceTabTarget === tab;
        button.classList.toggle("is-active", isActive);
        button.classList.toggle("button--secondary", isActive);
        button.classList.toggle("button--ghost", !isActive);
    });
    $91192e5600b60037$var$tabPanels.forEach((panel)=>{
        panel.hidden = panel.dataset.workspaceTabPanel !== tab;
    });
}
function $91192e5600b60037$var$applyState(nextState, options = {}) {
    $91192e5600b60037$var$activateView(nextState.view);
    if (nextState.view === "records") $91192e5600b60037$var$activateTab(nextState.tab || $91192e5600b60037$var$state.tab || "catalog");
    if (!options.skipHistory) $91192e5600b60037$var$syncHistory();
    $91192e5600b60037$var$dispatchWorkspaceChange();
}
function $91192e5600b60037$var$parseLocationState() {
    const url = new URL(window.location.href);
    const hash = url.hash.replace("#", "");
    const compatibleState = $91192e5600b60037$var$COMPATIBLE_HASHES[hash];
    if (compatibleState) return compatibleState;
    const recordId = url.searchParams.get("recordId");
    const tab = url.searchParams.get("tab");
    const hasView = $91192e5600b60037$var$viewPanels.some((panel)=>panel.dataset.workspaceViewPanel === hash);
    if (recordId) return {
        view: "records",
        tab: tab || "editor"
    };
    if (hash === "records") return {
        view: "records",
        tab: tab || "catalog"
    };
    if (hasView) return {
        view: hash,
        tab: "catalog"
    };
    return {
        view: "overview",
        tab: "catalog"
    };
}
function $91192e5600b60037$var$navigate(detail = {}, options = {}) {
    const nextState = {
        tab: detail.tab || $91192e5600b60037$var$state.tab || "catalog",
        view: detail.view || $91192e5600b60037$var$state.view || "overview"
    };
    $91192e5600b60037$var$applyState(nextState, options);
}
document.addEventListener("click", (event)=>{
    const control = event.target.closest("[data-workspace-view-link], [data-workspace-view-target], .workspace-tab");
    if (!control) return;
    event.preventDefault();
    $91192e5600b60037$var$navigate({
        tab: control.dataset.workspaceTabTarget || undefined,
        view: control.dataset.workspaceViewLink || control.dataset.workspaceViewTarget || undefined
    });
});
window.addEventListener("workspace:navigate", (event)=>{
    $91192e5600b60037$var$navigate(event.detail || {});
});
window.addEventListener("hashchange", ()=>{
    $91192e5600b60037$var$applyState($91192e5600b60037$var$parseLocationState(), {
        skipHistory: true
    });
});
$91192e5600b60037$var$applyState($91192e5600b60037$var$parseLocationState(), {
    skipHistory: true
});


//# sourceMappingURL=index.bce288a5.js.map
